// Same 11-name Google Calendar palette Event/Booking/Holiday already use
// (see ColorsWrapper on the backend — keep in sync with GOOGLE_COLOR_CODES).
// `value` doubles as the CSS class name (`.tomato`, `.peacock`, ...) defined
// in app/assets/tailwind/application.css — plain hand-authored CSS, not
// Tailwind-generated utilities, so referencing it dynamically here is safe
// (nothing for Tailwind's JIT/purge to miss).
export const TASK_COLORS = [
  { value: 'tomato',    label: 'Tomato' },
  { value: 'flamingo',  label: 'Flamingo' },
  { value: 'tangerine', label: 'Tangerine' },
  { value: 'banana',    label: 'Banana' },
  { value: 'peacock',   label: 'Peacock' },
  { value: 'sage',      label: 'Sage' },
  { value: 'basil',     label: 'Basil' },
  { value: 'blueberry', label: 'Blueberry' },
  { value: 'lavender',  label: 'Lavender' },
  { value: 'grape',     label: 'Grape' },
  { value: 'graphite',  label: 'Graphite' },
]

// Mirrors ColorsWrapper::GOOGLE_COLOR_CSS_CODE — used for the drawer's
// color accent bar, which needs a live hex value as the user picks a swatch
// (Task#color_css_code from the API only reflects the last-saved color).
export const TASK_COLOR_HEX = {
  lavender:  '#7986cb',
  sage:      '#33b679',
  grape:     '#8f25aa',
  flamingo:  '#e77c73',
  banana:    '#f6bf27',
  tangerine: '#f5521d',
  peacock:   '#4386f5',
  graphite:  '#616161',
  blueberry: '#3f51b5',
  basil:     '#098143',
  tomato:    '#d50201',
}
